/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CompanyResponsiblePerson', 'model/FinancialsFiscalReport', 'model/PaymentDisturbance'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CompanyResponsiblePerson'), require('./FinancialsFiscalReport'), require('./PaymentDisturbance'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.FinancialsAndDecisionMakers = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CompanyResponsiblePerson, root.ForStractionServiceApi.FinancialsFiscalReport, root.ForStractionServiceApi.PaymentDisturbance);
  }
}(this, function(ApiClient, CompanyResponsiblePerson, FinancialsFiscalReport, PaymentDisturbance) {
  'use strict';




  /**
   * The FinancialsAndDecisionMakers model module.
   * @module model/FinancialsAndDecisionMakers
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>FinancialsAndDecisionMakers</code>.
   * @alias module:model/FinancialsAndDecisionMakers
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>FinancialsAndDecisionMakers</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FinancialsAndDecisionMakers} obj Optional instance to populate.
   * @return {module:model/FinancialsAndDecisionMakers} The populated <code>FinancialsAndDecisionMakers</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AvailableFreeFinancialTransactions')) {
        obj['AvailableFreeFinancialTransactions'] = ApiClient.convertToType(data['AvailableFreeFinancialTransactions'], 'Integer');
      }
      if (data.hasOwnProperty('CorporationGroupName')) {
        obj['CorporationGroupName'] = ApiClient.convertToType(data['CorporationGroupName'], 'String');
      }
      if (data.hasOwnProperty('CompanySigneeClause')) {
        obj['CompanySigneeClause'] = ApiClient.convertToType(data['CompanySigneeClause'], 'String');
      }
      if (data.hasOwnProperty('FiscalReports')) {
        obj['FiscalReports'] = ApiClient.convertToType(data['FiscalReports'], [FinancialsFiscalReport]);
      }
      if (data.hasOwnProperty('PaymentDisturbances')) {
        obj['PaymentDisturbances'] = ApiClient.convertToType(data['PaymentDisturbances'], [PaymentDisturbance]);
      }
      if (data.hasOwnProperty('ScoringScore')) {
        obj['ScoringScore'] = ApiClient.convertToType(data['ScoringScore'], 'String');
      }
      if (data.hasOwnProperty('ScoringRating')) {
        obj['ScoringRating'] = ApiClient.convertToType(data['ScoringRating'], 'String');
      }
      if (data.hasOwnProperty('ScoringLimit')) {
        obj['ScoringLimit'] = ApiClient.convertToType(data['ScoringLimit'], 'String');
      }
      if (data.hasOwnProperty('ResponsiblePersons')) {
        obj['ResponsiblePersons'] = ApiClient.convertToType(data['ResponsiblePersons'], [CompanyResponsiblePerson]);
      }
      if (data.hasOwnProperty('FiscalPeriodPurchaseErrorMessage')) {
        obj['FiscalPeriodPurchaseErrorMessage'] = ApiClient.convertToType(data['FiscalPeriodPurchaseErrorMessage'], 'String');
      }
      if (data.hasOwnProperty('AuxiliaryBusinessNames')) {
        obj['AuxiliaryBusinessNames'] = ApiClient.convertToType(data['AuxiliaryBusinessNames'], ['String']);
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} AvailableFreeFinancialTransactions
   * @default 0
   */
  exports.prototype['AvailableFreeFinancialTransactions'] = 0;
  /**
   * @member {String} CorporationGroupName
   * @default ''
   */
  exports.prototype['CorporationGroupName'] = '';
  /**
   * @member {String} CompanySigneeClause
   * @default ''
   */
  exports.prototype['CompanySigneeClause'] = '';
  /**
   * @member {Array.<module:model/FinancialsFiscalReport>} FiscalReports
   */
  exports.prototype['FiscalReports'] = undefined;
  /**
   * @member {Array.<module:model/PaymentDisturbance>} PaymentDisturbances
   */
  exports.prototype['PaymentDisturbances'] = undefined;
  /**
   * @member {String} ScoringScore
   * @default ''
   */
  exports.prototype['ScoringScore'] = '';
  /**
   * @member {String} ScoringRating
   * @default ''
   */
  exports.prototype['ScoringRating'] = '';
  /**
   * @member {String} ScoringLimit
   * @default ''
   */
  exports.prototype['ScoringLimit'] = '';
  /**
   * @member {Array.<module:model/CompanyResponsiblePerson>} ResponsiblePersons
   */
  exports.prototype['ResponsiblePersons'] = undefined;
  /**
   * @member {String} FiscalPeriodPurchaseErrorMessage
   * @default ''
   */
  exports.prototype['FiscalPeriodPurchaseErrorMessage'] = '';
  /**
   * @member {Array.<String>} AuxiliaryBusinessNames
   */
  exports.prototype['AuxiliaryBusinessNames'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


